import { useEffect } from 'react';
import { holdSession } from '../utils/sessionIdle';

/**
 * `active` iken hareketsizlik çıkışını READING_IDLE_MS'e uzatır (bkz.
 * utils/sessionIdle). Belge okuma, video izleme gibi sayfaya olay gelmeyen
 * ekranlar için.
 */
const useSessionHold = (active) => {
  useEffect(() => {
    if (!active) return undefined;
    return holdSession();
  }, [active]);
};

export default useSessionHold;
